interface OnOffFn {
  (eventName: string, callback: (e: any) => void): void
}

interface emitFn {
  (eventName: string, ...args: any[]): void
}

// 创建事件总线对象
function createEventBus(): {
  on: OnOffFn
  off: OnOffFn
  emit: emitFn
} {
  // eslint-disable-next-line @typescript-eslint/ban-types
  const events: { [key: string]: Function[] } = {}

  const on: OnOffFn = (eventName, callback) => {
    if (!events[eventName]) {
      events[eventName] = []
    }
    events[eventName].push(callback)
  }

  const off: OnOffFn = (eventName, callback) => {
    const eventCallbacks = events[eventName]
    if (eventCallbacks) {
      const index = eventCallbacks.indexOf(callback)
      if (index !== -1) {
        eventCallbacks.splice(index, 1)
      }
    }
  }

  const emit: emitFn = (eventName, ...args) => {
    const eventCallbacks = events[eventName]
    if (eventCallbacks) {
      eventCallbacks.forEach((callback) => {
        callback(...args)
      })
    }
  }

  return {
    on,
    off,
    emit,
  }
}

export default createEventBus()
